import React, {useEffect, useState} from 'react';
import _ from "lodash";
import {getSinglePrintfulInfo} from "../../services/printful-info-data.service";
import {PRINTFUL_INFO_IDS} from "../../constants/printful-info.constant";
import ShowProgressSpinner from "../../../common/ui/show-progress-spinner";
import ShowEmptyListMessage from "../../../design/components/common/show-empty-list-message";
import {PRINTFUL_PRODUCTS_FIELDS_LIST} from "../../constants/printful-products.constant";
import ProductImageSmall from "../../../pod/components/product-upload/product-image-small";
import {syncPrintfulProducts} from "../../../common/services/cloud-function-service";


const defaultFilterCriteria: any = {};

const PrintfulProductsList = () => {
    const [printfulProductInfo, setPrintfulProductInfo] = useState(null);
    const [printfulProductsList, setPrintfulProductsList] = useState(null);
    const [filterCriteria, setFilterCriteria] = useState(defaultFilterCriteria);
    const [dataFetchInProgress, setDataFetchInProgress] = useState(true);

    const getPrintfulProductsList = async () => {
        setDataFetchInProgress(true);

        const searchCriteriaList = [];

        _.forIn(filterCriteria, (value, attribute) => {
            if ((!_.isEmpty(value) || value === true) && value !== 'EMPTY') {
                searchCriteriaList.push({field: attribute, condition: '==', value: value});
            }
        });

        // const printfulProductsListResult = await searchPrintfulProductsWithSearchCriteria(searchCriteriaList);
        const printfulProductInfoResult = await getSinglePrintfulInfo(PRINTFUL_INFO_IDS.PRINTFUL_PRODUCTS);

        setPrintfulProductInfo(printfulProductInfoResult);
        setPrintfulProductsList(_.orderBy(printfulProductInfoResult?.products, ['parent_category', 'category', 'title'], ['asc', 'asc', 'asc']));
        setDataFetchInProgress(false);
    }

    useEffect(() => {
        getPrintfulProductsList();
    }, [filterCriteria]);

    const refreshPrintfulProductsList = async () => {
        await getPrintfulProductsList();
    }

    const startPrintfulProductsSyncProcess = async () => {
        setDataFetchInProgress(true);
        await syncPrintfulProducts();

        await refreshPrintfulProductsList();
        setDataFetchInProgress(false);
    }

    return (
        <>

            <div className="flex justify-between">

                <div className="flex justify-start items-center mt-2 -ml-2 mb-2 w-full">
                    <div className={'text-xl ml-2'}>
                        Products
                        {printfulProductInfo &&
                            <span className={'ml-2'}>({printfulProductInfo?.total})</span>
                        }
                    </div>

                    {/*<PrintfulProductsFilters
                        filterCriteria={filterCriteria}
                        setFilterCriteria={setFilterCriteria}/>*/}

                    <div className="ml-4">
                        <ShowProgressSpinner dataFetchInProgress={dataFetchInProgress}/>
                    </div>
                </div>

                <div className="text-center w-1/3 flex items-center justify-end">
                    <div>
                        <button
                            className="button-green px-4 py-2 flex items-center justify-center"
                            onClick={startPrintfulProductsSyncProcess}>
                            <span>Sync Products</span>
                        </button>
                    </div>
                </div>

            </div>

            <div className="flex justify-start">

                <div
                    className="w-full bg-white mt-4">

                    <ShowEmptyListMessage
                        dataList={printfulProductsList}
                        dataFetchInProgress={dataFetchInProgress}
                        label={'Printful Products'}/>

                    {printfulProductsList?.length > 0 &&
                        <div className={'table-container overflow-y-scroll border-y border-gray-400 bg-white'}>
                            <table className="w-full">
                                <thead className="">
                                <tr>
                                    <th className="p-2 border border-gray-400 bg-gray-400 text-white sticky top-0 w-12">S.No</th>
                                    {PRINTFUL_PRODUCTS_FIELDS_LIST?.map((printfulProductsField, rowIndex) => (
                                        <th key={`th-${rowIndex}`}
                                            className={`p-2 border border-gray-400 bg-gray-400 text-white sticky top-0 text-left pl-2 ${printfulProductsField?.cssClass}`}>{printfulProductsField?.label}</th>
                                    ))}
                                    <th className="p-2 border border-gray-400 bg-gray-400 text-white sticky top-0">
                                        Actions
                                    </th>
                                </tr>
                                </thead>
                                <tbody className="">
                                {printfulProductsList?.map((printfulProducts, rowIndex) => (
                                    <tr key={`row-${rowIndex}`} className="border border-gray-400">
                                        <td className="p-2 border border-gray-400 m-auto">
                                            <div className="flex justify-center w-12">
                                                {rowIndex + 1}
                                            </div>
                                        </td>

                                        {PRINTFUL_PRODUCTS_FIELDS_LIST?.map((printfulProductsField, columnIndex) => (
                                            <React.Fragment key={`column-${rowIndex}-${columnIndex}`}>
                                                <td className={`p-2 border border-gray-400 m-auto ${printfulProductsField?.cssClass}`}>
                                                    {printfulProductsField?.optionsMap &&
                                                        <>{printfulProductsField?.optionsMap[printfulProducts[printfulProductsField?.attribute]]?.name}</>
                                                    }

                                                    {!printfulProductsField?.optionsMap && printfulProductsField?.type !== 'list-string' &&
                                                        printfulProductsField?.type !== 'image' &&
                                                        <>
                                                            {printfulProducts[printfulProductsField?.attribute]}

                                                            {printfulProductsField?.secondaryAttribute &&
                                                                <div className={'text-gray-500 text-sm'}>
                                                                    {printfulProducts[printfulProductsField?.secondaryAttribute]}
                                                                </div>
                                                            }
                                                        </>
                                                    }

                                                    {printfulProductsField?.type === 'image' &&
                                                        <div>
                                                            <ProductImageSmall
                                                                imageUrl={printfulProducts[printfulProductsField?.attribute]}/>
                                                        </div>
                                                    }

                                                    {printfulProductsField?.type === 'list-string' &&
                                                        <>
                                                            {_.join(printfulProducts[printfulProductsField?.attribute], ', ')}
                                                        </>
                                                    }

                                                    {printfulProductsField?.type === 'list' &&
                                                        <>
                                                            {printfulProducts[printfulProductsField?.attribute]?.map((field, fieldIndex) => (
                                                                <div key={`field-${fieldIndex}`}>
                                                                    {field}
                                                                </div>
                                                            ))}
                                                        </>
                                                    }
                                                </td>
                                            </React.Fragment>
                                        ))}

                                        <td className="p-2 border border-gray-400 m-auto w-40">
                                            <div className="flex justify-center">

                                            </div>
                                        </td>
                                    </tr>
                                ))}
                                </tbody>
                            </table>
                        </div>
                    }
                </div>

            </div>

        </>
    )
}

export default PrintfulProductsList
